export default function NicknameModal({
  lang, darkMode, userProfile, currentFamily,
  nicknameValue, setNicknameValue,
  setEditingNickname, saveGroupNickname, tr,
}) {
  return (
    <div className="modal-overlay" onClick={function(e) { if (e.target === e.currentTarget) setEditingNickname(false); }}>
      <div className="modal">
        <h3 style={{ fontFamily: "Playfair Display, serif", fontSize: 18, marginBottom: 6 }}>
          {lang === "es" ? "Tu nombre en este grupo" : lang === "fi" ? "Nimesi tässä ryhmässä" : "Your name in this group"}
        </h3>
        <p style={{ fontSize: 13, color: "#999", marginBottom: 16 }}>
          {lang === "es"
            ? "Solo los miembros de este grupo verán este nombre. Tu nombre real se mantiene igual en otros grupos."
            : lang === "fi"
            ? "Vain tämän ryhmän jäsenet näkevät tämän nimen."
            : "Only members of this group will see this name. Your real name stays the same in other groups."}
        </p>
        <div className="campo">
          <label className="campo-label">
            {lang === "es" ? "Nickname en este grupo" : lang === "fi" ? "Lempinimi" : "Nickname in this group"}
          </label>
          <input
            className="campo-input"
            autoFocus
            placeholder={userProfile?.name || ""}
            value={nicknameValue}
            onChange={function(e) { setNicknameValue(e.target.value); }}
            onKeyDown={function(e) { if (e.key === "Enter") saveGroupNickname(); }}
          />
          <p style={{ fontSize: 11, color: "#aaa", marginTop: 4 }}>
            {nicknameValue.trim()
              ? (lang === "es" ? `Los demás te verán como "${nicknameValue.trim()}"` : `Others will see you as "${nicknameValue.trim()}"`)
              : (lang === "es" ? `Se usará tu nombre real: "${userProfile?.name}"` : `Your real name will be used: "${userProfile?.name}"`)}
          </p>
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
          <button className="btn btn-dorado" style={{ flex: 2 }} onClick={saveGroupNickname}>
            {lang === "es" ? "✓ Guardar" : lang === "fi" ? "✓ Tallenna" : "✓ Save"}
          </button>
          {(userProfile?.groupNicknames || {})[currentFamily?.id] && (
            <button className="btn btn-gris" style={{ flex: 1, color: "#c0392b" }} onClick={async function() {
              setNicknameValue("");
              await saveGroupNickname();
            }}>
              {lang === "es" ? "Quitar" : "Remove"}
            </button>
          )}
          <button className="btn btn-gris" style={{ flex: 1 }} onClick={function() { setEditingNickname(false); }}>
            {tr("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}
